import type { AcademicLevelDto } from '@_/api-contracts/common.ts';

type AcademicLevelGroup = AcademicLevelDto[];

export function groupAcademicLevels(academicLevels: AcademicLevelDto[]): AcademicLevelGroup[] {
  const curricula: Record<string, AcademicLevelDto[]> = {};

  academicLevels.forEach(level => {
    if (!level.curriculum) {
      throw new Error('Academic level does not have a curriculum');
    }

    const curriculumId = level.curriculum?.id;

    if (!curricula[curriculumId]) {
      curricula[curriculumId] = [];
    }

    curricula[curriculumId].push(level);
  });

  const groups: AcademicLevelDto[][] = [];

  Object.keys(curricula).forEach(key => {
    const levels = curricula[key];
    levels.sort((a, b) => (a.position < b.position ? -1 : 1));

    let currGroup: AcademicLevelDto[] = [];
    levels.forEach(level => {
      if (!currGroup.length) {
        currGroup.push(level);
      }

      if (currGroup[1] && level.position !== currGroup[1].position + 1) {
        groups.push(currGroup);
        currGroup = [level];
      }

      currGroup[1] = level;
    });

    if (currGroup) {
      groups.push(currGroup);
    }
  });

  return groups.map(group => (group[0].position === group[1].position ? [group[0]] : group));
}
